const LIVE_VIEW_FIELDS = [
  'price',
  'compareAtPrice',
  'sku',
  'barcode',
  'taxable',
  'tracked',
  'weight',
  'requiresShipping',
  'countryCodeOfOrigin',
  'harmonizedSystemCode',
  'options',
  'cost',
  'taxCode',
  'inventoryPolicy',
  'availableForSale',
  'title',
  'displayName',
];

/**
 * Merges a listing variant channel entry with its `live` snapshot for Live/Published display.
 * Identity fields stay on the channel entry; scalar listing fields come from `live` when present.
 */
export function resolveListingVariantLiveView(channelEntry) {
  if (!channelEntry) return null;

  const { live, ...rest } = channelEntry;
  if (!live) return channelEntry;

  const resolved = { ...rest };

  LIVE_VIEW_FIELDS.forEach((field) => {
    if (live[field] !== undefined) {
      resolved[field] = live[field];
    }
  });

  resolved.meta = live.meta ?? rest.meta;

  return resolved;
}

export default resolveListingVariantLiveView;
